import JSONScript from "../JsonScript";
import tryGetJson from "./tryGetJson";

const withJsonIsomorphism = (WrappedComponent, { scriptId, propName }) => {
  const WithJsonIsomorphism = props => {
    const outputProps = { ...props };
    if (CLIENT) {
      outputProps[propName] = tryGetJson(
        document.querySelector(`#${scriptId}`)?.textContent
      );
    }

    const content = outputProps[propName] ?? null;

    return (
      <>
        <JSONScript id={scriptId} content={content} />
        <WrappedComponent {...outputProps} />
      </>
    );
  };

  return WithJsonIsomorphism;
};

export default withJsonIsomorphism;
